// ##############################
// // // Modal component styles
// #############################

import { 
  positionValues, 
  textAlignValues,
  WebkitAppearanceValues,
  floatDirection,
  overflowValues
 } from './stylesConstants.jsx';

function modalStyle(theme) {
  let styles = {
    modalRoot: {
      overflow: "auto",
      alignItems: "unset",
      justifyContent: "unset"
    },
    modalWithBreakPoints: {
      [theme.breakpoints.up("xs")]: {
        minWidth: "unset",
      },
      [theme.breakpoints.up("sm")]: {
        minWidth: "600px",
      },
      [theme.breakpoints.up("md")]: {
        minWidth: "600px",
      },
      [theme.breakpoints.up("lg")]: {
        minWidth: "600px",
      },
      [theme.breakpoints.up("xl")]: {
        minWidth: "600px",
      },
    },
    modal: {
      [theme.breakpoints.up("sm")]: {
        maxWidth: "1000px",
        margin: "1.75rem auto"
      },
      [theme.breakpoints.up("xs")]: {
        width: "100%",
        margin: "1.75rem auto"
      },
      borderRadius: "6px",
      marginTop: "100px !important",
      overflow: "visible",
      maxHeight: "unset",
      height: "fit-content",
      backgroundColor: "#FFFFFF"
    },
    modalHeader: {
      borderBottom: "none",
      paddingTop: "24px",
      paddingRight: "24px",
      paddingBottom: "0",
      paddingLeft: "24px",
      minHeight: "16.43px"
    },
    modalTitle: {
      margin: "0",
      lineHeight: "1.42857143"
    },
    modalCloseButton: {
      color: "#999999",
      marginTop: "-12px",
      padding: "0",
      cursor: "pointer",
      background: "0 0",
      border: "0",
      fontSize: "inherit",
      opacity: .9,
      textShadow: "none",
      fontWeight: 700,
      lineHeight: "1",
    },
    modalClose: {
      width: "16px",
      height: "16px"
    },
    modalBody: {
      paddingTop: "24px",
      paddingRight: "24px",
      paddingBottom: "16px",
      paddingLeft: "24px",
    },
    modalFooter: {
      padding: "15px",
      paddingTop: "0",
      margin: "0"
    },
    modalFooterCenter: {
      marginLeft: "auto",
      marginRight: "auto"
    },
    instructionNoticeModal: {
      marginBottom: "25px"
    },
    imageNoticeModal: {
      maxWidth: "150px"
    },
    modalSmall: {
      width: "300px"
    },
    modalSmallBody: {
      paddingTop: "0"
    },
    modalSmallFooterFirstButton: {
      margin: "0",
      paddingLeft: "16px",
      paddingRight: "16px",
      width: "auto"
    },
    modalSmallFooterSecondButton: {
      marginBottom: "0",
      marginLeft: "5px"
    }
  };

  styles.modalBody.position = positionValues.relative;
  styles.modalBody.overflow = overflowValues.visible;

  styles.modalFooter.textAlign = textAlignValues.right
  
  styles.modalCloseButton.float = floatDirection.right;
  styles.modalCloseButton.WebkitAppearance = WebkitAppearanceValues.none;
  
  styles.modal.position = positionValues.relative;

  return styles;
}

export default modalStyle;
